export default __webpack_public_path__ + "static/media/figma-small.5683f3bc.svg";